import { Title as titleKey } from './pre'
import { planTypes } from '@/common/constants';
export default {
  name: 'AdditionalHost',
  data() {
    return {
      description: this.$t('billing.events.addon.hub_hosts_desc'),
      desc: this.$t('billing.events.addon.hub_hosts_attendees_desc_new'),
      title: this.$t(titleKey),
      logo: require('@/assets/plans/additional-host.svg'),
      planType: planTypes.ADDITIONAL_HOST
    };
  },
};
